export const timelineTextContainerSx = {
  '& p': {
    marginTop: 0,
    marginBottom: '0.25rem',
  },
} as const;

export const timelineAdditionalSx = {
  borderTop: '1px solid',
  borderColor: 'border.separator',
  color: 'text.secondary',
  fontSize: '13px',
  marginTop: '11px',
  paddingTop: '10px',
  '&:empty': {
    borderTop: 0,
    margin: 0,
    padding: 0,
  },
  '& p': {
    marginTop: 0,
    marginBottom: 0,
  },
} as const;

export const feedbackTimelineFooterSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '&:empty': {
    display: 'none',
  },
} as const;

export const baseTimelineEntrySx = {
  position: 'relative',
} as const;

export const timelineCardBodySx = {
  minHeight: 0,
  padding: '11px 16px 12px',
  whiteSpace: 'pre-line',
} as const;

export const timelineCardHeaderSx = {
  marginRight: '3rem',
  marginBottom: '15px',
  paddingRight: '1rem',
  '& small': {
    fontSize: '90%',
  },
} as const;

export const timelineCardDateTimeSx = {
  display: 'inline-block',
  marginRight: '7px',
  color: 'text.secondary',
} as const;
